import { EventEmitter } from "events";

const CHANGE = "change";

export const createId = () => new Date().getTime() + Math.random();

class BaseNotificationController extends EventEmitter {
  constructor() {
    super();
    this.notifications = [];
  }

  create = (type, notificationData) => {
    const id = createId();
    const hasSameMessage = this.notifications.some(
      notification => notification.message === notificationData.message
    );
    if (!hasSameMessage) {
      this.notifications.push({
        id,
        type,
        ...notificationData,
      });

      this.emitChange();
      return id;
    }
  };

  removeById = notificationId => {
    this.notifications = this.notifications.filter(
      n => notificationId !== n.id
    );
    this.emitChange();
  };

  removeAll = () => {
    this.notifications = [];
    this.emitChange();
  };

  removeByType = type => {
    this.notifications = this.notifications.filter(
      notification => notification.type !== type
    );
    this.emitChange();
  };

  emitChange = () => this.emit(CHANGE, this.notifications);

  addChangeListener = callback => super.addListener(CHANGE, callback);

  removeChangeListener = callback => super.removeListener(CHANGE, callback);
}

export default BaseNotificationController;
